class ComparisonChart extends HTMLElement {}

const initComparisonCharts = () => {
  const sections = document.querySelectorAll('[data-comparison-chart-mobile]');

  sections.forEach((section) => {
    const slider = section.querySelector('[data-comparison-chart-swiper]');
    const progressBar = section.querySelector('[data-comparison-chart-progress-bar]');

    if (!slider || slider.dataset.initialized === 'true') return;

    slider.dataset.initialized = 'true';

    if (typeof window.Swiper === 'undefined') {
      progressBar?.style.setProperty('width', '100%');
      return;
    }

    const swiper = new window.Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchOverflow: true,
      on: {
        init(instance) {
          updateComparisonChartProgress(instance, progressBar);
        },
        slideChange(instance) {
          updateComparisonChartProgress(instance, progressBar);
        }
      }
    });

    updateComparisonChartProgress(swiper, progressBar);
  });
};

const updateComparisonChartProgress = (swiper, progressBar) => {
  if (!swiper || !progressBar) return;

  const totalSlides = swiper.slides.length || 1;
  const currentSlide = swiper.realIndex + 1;
  const width = 100 / totalSlides;
  const translate = (currentSlide - 1) * 100;

  progressBar.style.width = `${width}%`;
  progressBar.style.transform = `translateX(${translate}%)`;
};

document.addEventListener('DOMContentLoaded', initComparisonCharts);
document.addEventListener('shopify:section:load', initComparisonCharts);

if (!customElements.get('comparison-chart')) {
  customElements.define('comparison-chart', ComparisonChart);
}